var i={divider:"divider--uz6wt",horizontal:"horizontal--X75Kv",vertical:"vertical--RMtD4",opacity1:"opacity1--VgYFF",opacity2:"opacity2--1liEo"};export{i as default};
//# sourceMappingURL=Divider.module.scss.js.map
